// const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:4003";

// async function postJson<T>(path: string, body: any): Promise<T> {
//   const res = await fetch(`${API_BASE}${path}`, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(body || {}),
//   });

//   const data = await res.json().catch(() => ({}));
//   if (!res.ok) {
//     throw new Error(data.error || data.message || "Request failed");
//   }
//   return data as T;
// }

// export type BootstrapResp = {
//   userId: string;
//   sessionToken: string;
//   next?: string;
//   message?: string;
// };

// export const authApi = {
//   // ✅ Option 2 bootstrap endpoint you added in backend
//   bootstrapTeledoctor: (email: string) =>
//     postJson<BootstrapResp>("/api/auth/teledoctor/bootstrap", { email }),

//   // 🔁 map these to YOUR backend paths (adjust if needed)
//   sendPhoneOtp: (phone: string, sessionToken: string) =>
//     postJson("/api/auth/doctor/send-phone-otp", { phone, sessionToken }),

//   verifyPhoneOtp: (phone: string, otp: string, sessionToken: string) =>
//     postJson("/api/auth/doctor/verify-phone-otp", { phone, otp, sessionToken }),

//   createPassword: (password: string, sessionToken: string, fullName?: string) =>
//     postJson("/api/auth/doctor/create-password", { password, sessionToken, fullName }),

//   submitProfile: (userId: string, profile: any) =>
//     postJson("/api/auth/doctor/profile/submit", { userId, profile }),

//   // login (adjust endpoint: you currently have /auth/login or /api/auth/login)
//   login: (email: string, password: string) =>
//     postJson("/auth/login", { email, password }),
// };
const API_BASE = process.env.REACT_APP_API_BASE || "https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/usermanagement";

async function postJson<T>(path: string, body: any): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body || {}),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || data.message || "Request failed");
  }
  return data as T;
}

export type BootstrapResp = {
  userId: string;
  sessionToken: string;
  inviteToken?: string;
  next?: string;
  message?: string;
};

export type LoginResp = {
  access_token?: string;
  id_token?: string;
  token_type?: string;
  expires_in?: number;
  scope?: string;
};

export const authApi = {
  // ✅ TELEDOC bootstrap: user enters email after email verification redirect
  // Backend should read Auth0 user_metadata.invite_token and return { userId, sessionToken, inviteToken }
  bootstrapTeledoctor: (email: string) =>
    postJson<BootstrapResp>("/api/auth/teledoctor/bootstrap", { email }),

  // ✅ TELEDOC: send OTP
  // IMPORTANT: phone must be E.164 like +919999999999
  sendPhoneOtp: (phone: string, sessionToken: string) =>
    postJson("/api/auth/doctor/send-phone-otp", { phone, sessionToken }),

  // ✅ TELEDOC: verify OTP -> should keep using SAME sessionToken
  verifyPhoneOtp: (phone: string, otp: string, sessionToken: string) =>
    postJson("/api/auth/doctor/verify-phone-otp", { phone, otp, sessionToken }),

  // ✅ TELEDOC: create password (+ optionally store fullName)
  createPassword: (password: string, sessionToken: string, fullName?: string) =>
    postJson("/api/auth/doctor/create-password", { password, sessionToken, fullName }),

  // ✅ TELEDOC: submit profile (JSON-only)
  // FIX: send doctorProfile key, not profile
  submitDoctorProfile: (userId: string, doctorProfile: any) =>
    postJson("/api/auth/doctor/profile/submit", { userId, doctorProfile }),

  // ✅ LOGIN
  // Your backend currently uses /api/auth/login OR /auth/login depending on router mounting.
  // In your index.ts you have:
  //   app.use('/api/auth', auth0Routes);
  // so the login endpoint should be:
  login: (email: string, password: string) =>
    postJson<LoginResp>("/api/auth/login", { email, password }),
};
